module.exports = __webpack_public_path__ + "media/images/orbit/right-arrow-dfcf9016e26a07397b82e2f7960fc217e966e95f4e99733b33fda43481c03999.png";